import NotFoundScreen from "../../shared/error/NotFoundScreen";
import { useStaticUpgradeProducts } from "../landing/UpgradeSection";
import { StaticLoadingScreen } from "../../shared/LoadingScreen";
import StaticErrorScreen from "../../shared/error/StaticErrorScreen";
import { CreateContractPageContent } from "./CreateContractPage";
import { getContractTypeName } from "./ContractTypeName";
import BenefitList from "../../shared/elements/BenefitList";
import { STANDARD_BENEFITS } from "../contract-type/StandardCard";
import styled from "styled-components";
import NokPrice from "@teamscheme/nok-price";

export const PriceWrapper = styled.p`
  font-size: 1.4em;
  font-weight: bold;
`;

export default function CreateStandardContractPage() {
  const products = useStaticUpgradeProducts();
  const standard = products.standard;
  if (products.isLoading) return <StaticLoadingScreen />;
  if (products.error) return <StaticErrorScreen />;
  if (!standard) return <NotFoundScreen />;

  const { contractType } = standard.product;

  return (
    <CreateContractPageContent
      title={`Oppgrader til ${getContractTypeName(contractType)}`}
      contractType={contractType}
    >
      <BenefitList benefits={STANDARD_BENEFITS} />
      <p>Når du har opprettet kontrakten kan du betale med Vipps eller kort.</p>
      <PriceWrapper>
        <NokPrice value={standard.product.price} />
      </PriceWrapper>
    </CreateContractPageContent>
  );
}
